export default "__VITE_ASSET__DhzBpMrh__"